import { Base } from './Base';

import animateScrollTo from 'animated-scroll-to';

const classes = {
  hide: 'display-none',
  sectionForm: 'addresses__section--form',
  sectionIgnore: 'addresses__section--ignore'
};

const selectors = {
  controlAddNew: '.addresses__control--add-new',
  controlCancel: '.addresses__control--cancel',
  controlDelete: '.addresses__control--delete',
  controlEdit: '.addresses__control--edit',
  error: '.form__error',
  section: '.addresses__section'
};

export class Addresses extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.handleControlClicks();
    this.clearAddForm();
  }

  handleControlClicks() {
    this.element.addEventListener('click', (e) => {
      const controlAddNew = e.target.closest(selectors.controlAddNew);
      const controlCancel = e.target.closest(selectors.controlCancel);
      const controlDelete = e.target.closest(selectors.controlDelete);
      const controlEdit = e.target.closest(selectors.controlEdit);

      if (controlAddNew) {
        e.preventDefault();
        this.closeAllSections();
        this.openTarget(controlAddNew.href, 'add');
      }

      if (controlCancel) {
        e.preventDefault();
        this.closeAllSections();
        this.openAllNonFormSections();
        this.clearAddForm();
        this.scrollToTop();
      }

      if (controlDelete) {
        const prompt = controlDelete.nextElementSibling;

        if (prompt) {
          if (!window.confirm(prompt.innerText)) {
            e.preventDefault();
          }
        }
      }

      if (controlEdit) {
        e.preventDefault();
        this.closeAllSections();
        this.openTarget(controlEdit.href, 'edit');
      }
    });
  }

  closeAllSections() {
    this.element.querySelectorAll(selectors.section).forEach((section) => {
      if (!section.classList.contains(classes.sectionIgnore)) {
        section.classList.add(classes.hide);
      }
    });
  }

  openAllNonFormSections() {
    const { title } = this.refs;

    if (title && title.dataset.textDefault) {
      title.innerHTML = title.dataset.textDefault;
    }

    this.element.querySelectorAll(selectors.section).forEach((section) => {
      if (!section.classList.contains(classes.sectionForm)) {
        section.classList.remove(classes.hide);
      }
    });
  }

  openTarget(href, type) {
    const { title } = this.refs;
    const id = href.split('#')[1];
    const target = document.getElementById(id);

    if (target) {
      target.classList.remove(classes.hide);
    }

    if (title && type === 'add' && title.dataset.textAdd) {
      title.innerHTML = title.dataset.textAdd;
    }

    if (title && type === 'edit' && title.dataset.textEdit) {
      title.innerHTML = title.dataset.textEdit;
    }
  }

  clearAddForm() {
    const form = document.getElementById('address-add-new');

    if (form) {
      const inputs = form.querySelectorAll('input');

      inputs.forEach((input) => {
        input.value = '';

        if (input.type  === 'checkbox') {
          input.checked = false;
        }
      });

      const errors = form.querySelectorAll(selectors.error);

      errors.forEach((error) => {
        error.parentNode.removeChild(error);
      });
    }
  }

  scrollToTop() {
    animateScrollTo(0, {
      maxDuration: 500
    });
  }
}